import type { Mechanic } from '@juegazo/shared';

export interface MechanicInfo {
  name: string;
  description: string;
  example: string;
}

export const MECHANIC_INFO: Record<Mechanic, MechanicInfo> = {
  category: {
    name: 'Categoría',
    description: 'Di un elemento que pertenezca a la categoría indicada.',
    example: 'Categoría "Animales": perro...',
  },
  starts_with_letter: {
    name: 'Comienza por',
    description: 'Di una palabra que empiece con la letra o sílaba indicada.',
    example: 'Letra "M": manzana...',
  },
  contains: {
    name: 'Contiene',
    description: 'Di una palabra que contenga la secuencia de letras indicada.',
    example: 'Contiene "RRO": perro...',
  },
  excludes_letter: {
    name: 'No contienen',
    description: 'Di una palabra que NO contenga la letra/secuencia indicada.',
    example: 'Sin letra "E": aroma...',
  },
  chain: {
    name: 'Inicia con la última letra',
    description: 'Di una palabra que empiece con la última letra de la respuesta anterior.',
    example: 'gato → oveja → árbol...',
  },
  dual_condition: {
    name: 'Dos condiciones',
    description: 'Cumple dos restricciones a la vez (categoría + letra, etc.).',
    example: 'Animal que empieza con "P": perro...',
  },
  name_three: {
    name: 'Nombra 3',
    description: 'Di 3 elementos de la categoría en el menor tiempo posible.',
    example: 'Categoría "Frutas": manzana, pera, uva...',
  },
};
